define('app.env',[

], function(
    
){

    return window.SE.APPENV;

});
